// eslint-disable-next-line import/prefer-default-export
export const EmployeeShiftLineTemplateAction = Object.freeze({
    Save: 0,
    Load: 1,
});
